import { breakpointSizes, Size, Container } from "@brightagency/headstart-common";
import React, { useRef } from "react";
import { WPPost } from "../../../constants/types";
import { LocalInformationPostTypeACF } from "../../../constants/types/acf";
import { useBreakpoint } from "../../../controllers";
import { getWpPostUrl } from "../../../utils";
import { ArrowRight } from "../../atoms/Icons/ArrowRight";
import { Grid } from "../../molecules/Grid";
import { PopulationCard } from "../../molecules/PopulationCard";
import { Appearances } from "../../molecules/PopulationCard/styled";
import { Carousel, usePagedHorizontalScrolling } from "../Carousel";
import { CarouselSection } from "../CarouselSection";
import { Title, Link, Outer } from "./styled";

const gridBreakpoints = [
    { breakpointWidth: breakpointSizes.xsmall, columns: 1, gutter: 10 },
    { breakpointWidth: breakpointSizes.medium, columns: 3, gutter: 16 },
    { breakpointWidth: breakpointSizes.large, columns: 4, gutter: 30 },
];

interface Props {
    id: string;
    title: string;
    items: WPPost<LocalInformationPostTypeACF>[];
    isCarousel: boolean;
}

export const LocalInformationV2: React.FC<Props> = props => {
    const largeBreakpoint = useBreakpoint(Size.large, 50);
    const trackRef = useRef<HTMLDivElement>(null);
    const itemWidth = largeBreakpoint ? 325 : 150;
    const itemGutter = largeBreakpoint ? 16 : 8;
    const scrollAmount = itemWidth + itemGutter;
    const { scrollLeft, scrollRight, canScroll } = usePagedHorizontalScrolling({
        trackRef,
        pageWidth: scrollAmount,
        contentCount: props.items.length,
    });

    return (
        <>
            {props.isCarousel ? (
                <CarouselSection
                    id={props.id}
                    title={props.title}
                    carousel={{
                        onScrollLeft: scrollLeft,
                        onScrollRight: scrollRight,
                        canScroll,
                        displayControl: true,
                        content: (
                            <Carousel scrollingRef={trackRef} itemWidth={itemWidth} itemGutter={itemGutter}>
                                {props.items.map(item => (
                                    <PopulationCard
                                        appearance={Appearances.secondary}
                                        key={item.id}
                                        to={getWpPostUrl(item)}
                                        title={item.title.rendered}
                                        image={item.acf.meta?.hero_image}
                                    />
                                ))}
                            </Carousel>
                        ),
                    }}
                />)
                : 
                (
                    <Container>
                        <Outer>
                            <Title>{props.title}</Title>
                            <Grid breakpoints={gridBreakpoints}>
                                {props.items.map(item => (
                                    <Link
                                        key={item.id}
                                        to={getWpPostUrl(item)}
                                    >
                                        {item.title.rendered} <ArrowRight />
                                    </Link>
                                ))}
                            </Grid>
                        </Outer>
                    </Container>
                )
            }
        </>
    )
}
